import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import DownloadIcon from '@/components/Icons/DownloadIcon';
import ViewIcon from '@/components/Icons/ViewIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
// import { ISelectOption } from '@/components/ui/SearchSelectBox';
import useFilter from '@/hooks/useFilter';
import { IPageInfo } from '@/interfaces/common.model';
import { ICompany } from '@/interfaces/company.model';
// import { setUpdateFilterStates } from '@/redux/features/UserSlice';
import { RootState } from '@/redux/store';
import ExportDataHandler from '@/utility/CommonFunctions';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { useCallback, useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import { SingleValue } from 'react-select';
interface ITeamPayslipPagination extends IPageInfo {
  count: number;
  tableLoader: boolean;
  searchQuery: string;
}
interface ITeamPayTableData {
  id: string;
  name: string;
  AttendanceLockStatus: boolean;
  salaryStatus: boolean;
  isSalaryCreated: boolean;
}
interface ITeamPayState {
  companyList: ICompany[];
  sitesList: ITeamPayTableData[];
  cardCounts: {
    totalSalaryCreated: number | boolean;
    totalAttendanceLocked: number | boolean;
  };
}
interface ITeamPayslip {
  id: string;
  isSalaryCreated: boolean;
  isAttendnaceLocked: boolean;
  name: string;
}
interface ITeamPayslipRes {
  status: boolean;
  data: ITeamPayslip[];
  message: string;
}

const TeamPayslips = () => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const dateFilter = useSelector((state: RootState) => state?.user?.months);
  const filtersStates = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const [state, setState] = useState<ITeamPayState>({
    companyList: [],
    sitesList: [],
    cardCounts: {
      totalSalaryCreated: 0,
      totalAttendanceLocked: 0,
    },
  });
  const [pagination, setPagination] = useState<ITeamPayslipPagination>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    searchQuery: '',
  });

  const tableHeading: ITableColumn<ITeamPayTableData>[] = [
    { value: 'name', label: 'Office Name' },
    { value: 'AttendanceLockStatus', label: 'Attendance Lock Status' },
    { value: 'salaryStatus', label: 'Salary Status' },
  ];

  const getPaySlip = useCallback(async () => {
    setPagination((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    const filter = {
      startDate: dateFilter[0],
      endDate: dateFilter[1],
      search: pagination?.searchQuery,
      companyId: filtersStates?.companyId,
    };
    try {
      const API =
        API_URL +
        API_ENDPOINT?.getOfficeForTeamPayslip +
        '?' +
        getFilterUrl(filter);
      const response: ITeamPayslipRes = await callApi(API, {
        method: 'GET',
      });
      if (response?.status === true) {
        const newData = response?.data?.map((item) => ({
          ...item,
          id: item?.id,
          salaryStatus: item?.isSalaryCreated,
          AttendanceLockStatus: item?.isAttendnaceLocked,
        }));
        const totalSalaryCreated = response?.data?.filter(
          (item) => item?.isSalaryCreated === true,
        ).length;
        const totalAttendanceLocked = response?.data?.filter(
          (item) => item?.isAttendnaceLocked === true,
        ).length;
        setState((pre) => ({
          ...pre,
          sitesList: newData,
          cardCounts: {
            totalSalaryCreated,
            totalAttendanceLocked,
          },
        }));
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPagination((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  }, [dateFilter, pagination?.searchQuery, filtersStates?.companyId]);

  useEffect(() => {
    getPaySlip();
  }, [getPaySlip]);

  // const getCompanyList = async ()=> {
  //   // try {
  //   //   const API = API_URL + API_ENDPOINT?.getCompany;
  //   //   const response: ICompanyResponse = await callApi(API, {
  //   //     method: 'GET',
  //   //   });
  //   //   if (response?.status === true) {
  //   //     setState((prev) => ({
  //   //       ...prev,
  //   //       companyList: response?.data,
  //   //     }))
  //   //   }
  //   // } catch (error) {
  //   //   return [];
  //   // }
  // };

  const { singleDateChangeHandler, handleSearchChange } = useFilter(
    pagination,
    setPagination,
  );

  // const handleCompanySearch = (
  //   data: SingleValue<ISelectOption>,
  //   type: string,
  // ) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     ...(type === 'site' && { siteId: data?.site }),
  //     ...(type == 'companyId' && {
  //       // companyId: data?.companyId,
  //       siteId: '',
  //     }),
  //   }));
  //   dispatch(
  //     setUpdateFilterStates({
  //       [type]: data?.value,
  //     }),
  //   );
  // };
  const handleExport = (data: ITeamPayTableData) => {
    if (!data?.isSalaryCreated) {
      showToastNotification('danger', 'Salary has not been created yet.');
      return;
    }
    const exportData = {
      exportDataType: 'salaryData',
      siteId: data?.id,
      months: dateFilter,
      search: pagination?.searchQuery,
      companyId: filtersStates?.companyId,
    };
    ExportDataHandler(exportData);
  };

  const actionData = [
    {
      label: 'Download',
      className: 'btn btn-link',
      icon: <DownloadIcon />,
      title: 'Download',
      clickHandler: handleExport,
    },
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view site users',
      clickHandler: (data: ITeamPayTableData) => {
        navigate(`${RoutesLink?.payslipOfficeWise}/${data?.id}`, {
          state: { data: { name: data?.name }, month: dateFilter },
        });
      },
    },
  ];

  return (
    <Layout>
      <div className="content">
        <MainHeading
          title="Team Payslip"
          showDefaultDate={true}
          singleDateChangeHandler={singleDateChangeHandler}
          pickerType="month"
          pageState={{
            sortBySingleDate: dateFilter,
          }}
        />
        <div className="row mb-4">
          {[
            {
              title: 'Total Salary Created',
              value: state?.cardCounts?.totalSalaryCreated || 0,
              color: 'text-success',
            },
            {
              title: 'Total Attendance Locked',
              value: state?.cardCounts?.totalAttendanceLocked || 0,
              color: 'text-primary',
            },
          ].map((card, index) => (
            // <div key={index} className="col-md-12 col-sm-6 mb-3">
            <div key={index} className="col-md-6 col-sm-12 mb-3">
              <div className="card shadow h-100">
                <div className="card-body text-center">
                  <h4 className="text-muted">{card.title}</h4>
                  <h3 className={`fw-bold ${card.color}`}>{card.value}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
        <CardLayout cardStyle="mb-4" isGrid={tableView === 'grid'}>
          <FilterComponent
            isGrid={false}
            searchPlaceHolder="Search"
            handleSearch={handleSearchChange}
            // companyList={state?.companyList}
            // handleSearchChange={handleCompanySearch}
            // getCompanyList={getCompanyList}
          />
          <CommonTable
            tableHeading={tableHeading}
            tableData={state?.sitesList}
            ActionData={actionData}
            count={pagination?.count}
            totalPages={pagination?.totalPages}
            pageSize={pagination?.pageSize ?? 0}
            currentPage={pagination?.currentPage}
            isLoading={pagination?.tableLoader}
          />
        </CardLayout>
      </div>
    </Layout>
  );
};

export default TeamPayslips;
